import React, { useState } from "react";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import AddIcon from "@mui/icons-material/Add";
import PublicIcon from "@mui/icons-material/Public";
import WorkIcon from "@mui/icons-material/Work";
import { useSelector } from "react-redux";
import AddTradeModal from "../common/AddTradeModal";
import AddWebsiteModal from "../common/AddWebsiteModal";
import DeleteConfirmation from "../common/DeleteConfirmation";
import AddManufactureModal from "../common/AddManufactureModal";
import AddDescriptionModal from "../common/AddDescriptionModal";
import Loader from "../../common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { DELETE_TRADE_PRODUCT } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { English } from "../../constant/EnglishFallback";
import VerifiedIcon from "@mui/icons-material/Verified";

const ProductAboutSection = ({
  productDetails,
  tradeList,
  onTradesSaveSuccessfully,
  onProductDetailsSaveSuccessfully,
  isVerified = false,
  type = "unknown",
  color = ""
}) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const [showAddTradesModal, setShowAddTradeOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedTradeId, setSelectedTradeId] = useState(0);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [basicDetailsModalType, setBasicDetailsModalType] = useState(null);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const LanguageData = multiLanguageData?.Products || {};
  const {
    BUTTON_ABOUT = English.Products.BUTTON_ABOUT,
    TEXT_NO_INFO_PRODUCT = English.Products.TEXT_NO_INFO_PRODUCT,
    TEXT_NO_INFO_PRODUCT_SUBTEXT = English.Products.TEXT_NO_INFO_PRODUCT_SUBTEXT,
    TEXT_TRADE_COMPONY = English.Products.TEXT_TRADE_COMPONY,
    TEXT_ADD_MANUFACTURER = English.Products.TEXT_ADD_MANUFACTURER,
    TEXT_ADD_WEBSITE = English.Products.TEXT_ADD_WEBSITE,
    TEXT_ADD_DESCRIPTION = English.Products.TEXT_ADD_DESCRIPTION,
    TEXT_DELETE_PRODUCT_TARDES = English.Products.TEXT_DELETE_PRODUCT_TARDES,
    TEXT_DELETE_COMPANY_TARDES_DEC = English.Products.TEXT_DELETE_COMPANY_TARDES_DEC
  } = LanguageData || {};

  const onTradeItemClick = (id) => {
    if (!id) return;
    setSelectedTradeId(id);
    setConfirmDeleteModalOpen(true);
  };

  const handleWebRedirect = (inputUrl) => {
    try {
      let fullUrl = new URL(inputUrl);
      let baseUrl = `${fullUrl.hostname}`;
      window.open(`http://${baseUrl}`, "_blank");
    } catch (error) {
      window.open(`http://${inputUrl}`, "_blank");
    }
  };

  const extractBaseURL = (inputUrl) => {
    try {
      let fullUrl = new URL(inputUrl);
      return `${fullUrl?.hostname}`;
    } catch (error) {
      return inputUrl;
    }
  };

  const handleDeleteTrade = async () => {
    try {
      setLoading(true);
      const obj = {
        UserId: currentUserId,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [
          {
            TradeId: selectedTradeId,
            ProductId: productDetails.id
          }
        ]
      };
      const res = await Postrequestcall(DELETE_TRADE_PRODUCT, obj, loginData?.accessToken);
      if (res?.status === 201) {
        onTradesSaveSuccessfully();
        setConfirmDeleteModalOpen(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  // --------- VERIFIED Layout ---------
  if (isVerified) {
    const nothingToShow =
      !tradeList.length &&
      !productDetails?.manufacturerName &&
      !productDetails?.productWebsite &&
      !productDetails?.description;
    return (
      <>
        <Card sx={{ p: 2 }}>
          {/* Manufacturer */}
          {productDetails?.manufacturerName && (
            <Stack direction="row" spacing={2} alignItems="center" mb={2}>
              {/* <WorkIcon color="primary" /> */}
              <Avatar src={productDetails?.logo} />
              <Typography variant="h5" style={{ color: BIBlue, cursor: 'pointer' }} onClick={() => navigate(`/manufacture/${productDetails?.manufacturerId}`)}>{productDetails?.manufacturerName}</Typography>
              {productDetails?.manufacturerVerified && <VerifiedIcon sx={{ color: BIBlue }} />}
            </Stack>
          )}

          <Typography variant="body1" sx={{ mb: 1 }}>
            {productDetails?.description}
          </Typography>
          {nothingToShow && (
            <Stack spacing={1} textAlign="center">
              <Typography variant="body2" color="textSecondary">
                {TEXT_NO_INFO_PRODUCT}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {TEXT_NO_INFO_PRODUCT_SUBTEXT}
              </Typography>
            </Stack>
          )}

          <Stack gap={2}>
            {/* Group */}
            {productDetails?.group?.groupName && (
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body1" fontWeight={600}>
                  Group:
                </Typography>
                <Typography variant="body1">
                  {productDetails?.group?.groupName}
                </Typography>
              </Stack>
            )}

            {/* Properties */}
            {productDetails?.properties && productDetails?.properties?.length > 0 && (
              <Stack spacing={0.5}>
                {(() => {
                  // Group properties by name and combine values
                  const groupedProperties = productDetails?.properties?.reduce((acc, property) => {
                    const name = property?.propertyName;
                    const value = property?.propertyOptionValue;
                    if (!acc[name]) {
                      acc[name] = [];
                    }
                    if (value && !acc[name].includes(value)) {
                      acc[name].push(value);
                    }
                    return acc;
                  }, {});

                  return Object.entries(groupedProperties).map(([name, values], index) => (
                    <Stack key={index} direction="row" spacing={1} alignItems="center">
                      <Typography variant="body1" fontWeight={600}>
                        {name}:
                      </Typography>
                      <Typography variant="body1">
                        {values.join(", ")}
                      </Typography>
                    </Stack>
                  ));
                })()}
              </Stack>
            )}

            {/* Trade List */}
            {tradeList?.length > 0 ? (
              <Stack direction="row" spacing={1} gap={1} alignItems="center" flexWrap="wrap" mt={1}>
                <Chip
                  key={9990}
                  size="small"
                  label={type?.trim()}
                  sx={{ mb: 1, borderRadius: "5px" }}
                />
                {tradeList
                  ?.sort(
                    (a, b) =>
                      a.tradeType?.toLowerCase().localeCompare(b.tradeType?.toLowerCase()) ||
                      a.tradeName
                        ?.trim()
                        .toLowerCase()
                        .localeCompare(b.tradeName?.trim().toLowerCase())
                  )
                  .map((item, index) => (
                    <Chip
                      key={index}
                      label={item.tradeName?.trim()}
                      size="small"
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          item.tradeType?.toLowerCase() === "main" ? BIBlue : undefined,
                        color: item.tradeType?.toLowerCase() === "main" ? "white" : undefined,
                        borderRadius: "5px"
                      }}
                    // onClick={() => onTradeItemClick(item?.tradeId ?? 0)}
                    />
                  ))}
              </Stack>
            ) : (
              <Chip
                size="small"
                key={9990}
                label={type?.trim()}
                sx={{ mb: 1, borderRadius: "5px", width: "100px" }}
              />
            )}

            {/* Website */}
            {productDetails?.productWebsite && (
              <Stack direction="row" spacing={2} alignItems="center">
                <PublicIcon sx={{ color: color }} color="primary" />
                <span
                  style={{
                    color: BIBlue,
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                  onClick={() => handleWebRedirect(productDetails?.productWebsite)}>
                  {extractBaseURL(productDetails?.productWebsite)}
                </span>
              </Stack>
            )}
          </Stack>
        </Card>
        {/* {confirmDeleteModalOpen && (
          <DeleteConfirmation
            open={confirmDeleteModalOpen}
            onClose={() => setConfirmDeleteModalOpen(false)}
            headerText={TEXT_DELETE_PRODUCT_TARDES}
            secondaryText={TEXT_DELETE_COMPANY_TARDES_DEC}
            onBadgeClick={handleDeleteTrade}
          />
        )} */}
      </>
    );
  }

  // --------- NON-VERIFIED Layout ---------
  return (
    <>
      <Card className="pagelist-content" sx={{ p: 2 }}>
        <Typography variant="h6">{BUTTON_ABOUT}</Typography>
        {tradeList.length === 0 &&
          productDetails?.info === "" &&
          productDetails?.manufacturerName === "" &&
          productDetails?.productWebSite === "" ? (
          <Stack spacing={1} p={1} textAlign="center">
            <Typography variant="body2" color="textSecondary">
              {TEXT_NO_INFO_PRODUCT}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {TEXT_NO_INFO_PRODUCT_SUBTEXT}
            </Typography>
          </Stack>
        ) : null}

        {/* Trades */}
        {(tradeList?.length !== 0 || !pathname.includes("proxySite")) && (
          <Stack>
            {tradeList?.length !== 0 ? (
              <Stack direction="row" alignItems="center" flexWrap="wrap" spacing={1} gap={1} mb={2}>
                {type && (
                  <Chip
                    key={9990}
                    label={type?.trim() || "Unknown"}
                    sx={{ mb: 1, width: "80px" }}
                  />
                )}
                {tradeList
                  ?.sort(
                    (a, b) =>
                      a.tradeType?.toLowerCase().localeCompare(b.tradeType?.toLowerCase()) ||
                      a.tradeName
                        ?.trim()
                        .toLowerCase()
                        .localeCompare(b.tradeName?.trim().toLowerCase())
                  )
                  .map((item, index) => (
                    <Chip
                      key={index}
                      label={item.tradeName?.trim()}
                      style={{
                        cursor: !pathname.includes("proxySite") ? "pointer" : "default",
                        backgroundColor:
                          item?.tradeType?.toLowerCase() === "main" ? BIBlue : undefined,
                        color: item?.tradeType?.toLowerCase() === "main" ? "white" : undefined
                      }}
                      onClick={() => {
                        if (!pathname.includes("proxySite")) onTradeItemClick(item?.tradeId ?? 0);
                      }}
                    />
                  ))}
                {!pathname.includes("proxySite") && (
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => setShowAddTradeOpenModal(true)}
                    style={{ backgroundColor: BIBlue, color: "white" }}>
                    <AddIcon style={{ fontSize: "16px" }} />
                  </IconButton>
                )}
              </Stack>
            ) : (
              !pathname.includes("proxySite") && (
                <>
                  {type && (
                    <Chip
                      key={9990}
                      label={type?.trim() || "Unknown"}
                      sx={{ mb: 1, width: "80px" }}
                    />
                  )}
                  <Stack direction="row" mb={2}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => setShowAddTradeOpenModal(true)}
                      style={{ borderRadius: "30px" }}>
                      {TEXT_TRADE_COMPONY}
                    </Button>
                  </Stack>
                </>
              )
            )}
          </Stack>
        )}

        <Stack gap={2}>
          {/* Manufacturer */}
          {(!pathname.includes("proxySite") || productDetails?.manufacturerName) && (
            <Stack>
              {productDetails?.manufacturerName ? (
                <Stack direction="row" spacing={2}>
                  <WorkIcon color="primary" />
                  <p style={{ color: BIBlue, cursor: 'pointer' }} onClick={() => navigate(`/manufacture/${productDetails?.manufacturerId}`)}>{productDetails?.manufacturerName}</p>
                </Stack>
              ) : (
                !pathname.includes("proxySite") && (
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <WorkIcon color="primary" />
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => setBasicDetailsModalType("manufacture")}
                      style={{ width: "100%" }}>
                      {TEXT_ADD_MANUFACTURER}
                    </Button>
                  </Stack>
                )
              )}
            </Stack>
          )}

          {/* Website */}
          {(productDetails?.productWebSite || !pathname.includes("proxySite")) && (
            <Stack>
              {productDetails?.productWebsite ? (
                <Stack direction="row" spacing={2}>
                  <PublicIcon color="primary" />
                  <span
                    style={{
                      color: BIBlue,
                      cursor: "pointer",
                      textDecoration: "none"
                    }}
                    onClick={() => handleWebRedirect(productDetails?.productWebsite)}>
                    {extractBaseURL(productDetails?.productWebsite)}
                  </span>
                </Stack>
              ) : (
                !pathname.includes("proxySite") && (
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <PublicIcon color="primary" />
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => setBasicDetailsModalType("website")}
                      style={{ width: "100%" }}>
                      {TEXT_ADD_WEBSITE}
                    </Button>
                  </Stack>
                )
              )}
            </Stack>
          )}

          {/* Info */}
          {(productDetails?.description || !pathname.includes("proxySite")) && (
            <Stack>
              {productDetails?.description ? (
                <Stack direction="row" spacing={2}>
                  <Typography variant="body1" sx={{ wordBreak: "break-all" }}>
                    {productDetails?.description}
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setBasicDetailsModalType("info")}
                    style={{ width: "100%" }}>
                    {TEXT_ADD_DESCRIPTION}
                  </Button>
                </Stack>
              )}
            </Stack>
          )}
        </Stack>
      </Card>

      {showAddTradesModal && (
        <AddTradeModal
          open={showAddTradesModal}
          onClose={() => setShowAddTradeOpenModal(false)}
          alreadyTradesSelected={tradeList}
          mainId={productDetails?.id}
          from="product"
          onTradesSaveSuccessfully={onTradesSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "website" && (
        <AddWebsiteModal
          open={true}
          onClose={() => setBasicDetailsModalType(null)}
          from="product"
          data={productDetails}
          onDataSave={onProductDetailsSaveSuccessfully}
          onSaveClick={() => { }}
        />
      )}

      {basicDetailsModalType === "info" && (
        <AddDescriptionModal
          open={true}
          onClose={() => setBasicDetailsModalType(null)}
          from="product"
          data={productDetails}
          onDataSave={onProductDetailsSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "manufacture" && (
        <AddManufactureModal
          open={true}
          onClose={() => setBasicDetailsModalType(null)}
          from="productProfile"
          productDetails={productDetails}
          onDataSave={onProductDetailsSaveSuccessfully}
        />
      )}

      {confirmDeleteModalOpen && (
        <DeleteConfirmation
          open={confirmDeleteModalOpen}
          onClose={() => setConfirmDeleteModalOpen(false)}
          headerText={TEXT_DELETE_PRODUCT_TARDES}
          secondaryText={TEXT_DELETE_COMPANY_TARDES_DEC}
          onBadgeClick={handleDeleteTrade}
        />
      )}
    </>
  );
};

export default ProductAboutSection;
